import { atom } from 'jotai'

/**
 * 運行実績CSVインポートModalの表示状態
 */
export const isOpenTourCsvImportModalAtom = atom<boolean>(false)

isOpenTourCsvImportModalAtom.debugLabel = 'isOpenTourCsvImportModalAtom'
